import styled from "@emotion/styled";
import { palette } from "@jnpmedi/grebob";
import { GrStack } from "@jnpmedi/grebob/dist/components/layout/GrStack";
import { CookieHelper } from "@jnpmedi/helper-session";
import { langHelper, MvnMessage } from "@newLibs/utils";
import { Markdown } from "./Markdown";
import { DOCS_POPUP_DATE_FORMAT, DOCS_RELEASE_POPUP_KEY } from "./Popup";
import Style from "./Popup.style";
import { isAdminReleaseLang } from "@maven-rest/admin/Release.conv";
import { AdminReleaseWithContent } from "@maven-rest/admin/Release.dto";
import { readableMavenProductService } from "@maven-rest/common/common.conv";
import { LoLang, LoString } from "@maven-rest/common/common.types";
import { getCurrentDate } from "@maven-helper/functions/Misc.function";
import dayjs from "dayjs";

interface ReleasePopupProps {
  release: AdminReleaseWithContent;
  onClose: () => void;
}

export function ReleasePopup(props: ReleasePopupProps) {
  const { release, onClose } = props;
  const { service, version, updatedAt, content } = release;

  const loLang = langHelper.getLang();
  const lang = isAdminReleaseLang(loLang) ? loLang : LoLang.KO;

  const handleReleasePopupClose = () => {
    CookieHelper.setCookie(DOCS_RELEASE_POPUP_KEY, version, dayjs(getCurrentDate()).add(1, "day").toDate());

    onClose();
  };

  return (
    <Style.PopupWrapper>
      <GrStack height="calc(100% - 40px)" flexDirection="column">
        <Style.TextWrapper fontSize="1.25rem" fontWeight={700} style={{ marginBottom: "1.5rem" }}>
          Version & Release
        </Style.TextWrapper>
        <StyledContentWrapper>
          <Style.PopupInfoWrapper height="92px">
            <Style.TextWrapper fontSize="1rem" fontWeight={700}>
              {readableMavenProductService(service)}
            </Style.TextWrapper>
            <StyledReleaseTitleWrapper>
              <StyledLabelTextWrapper width="6.5rem">Current Version</StyledLabelTextWrapper>
              <Style.TextWrapper>{version}</Style.TextWrapper>
              <StyledLabelTextWrapper style={{ marginLeft: "2rem" }}>Updated</StyledLabelTextWrapper>
              <Style.TextWrapper>{dayjs(updatedAt).format(DOCS_POPUP_DATE_FORMAT)}</Style.TextWrapper>
            </StyledReleaseTitleWrapper>
          </Style.PopupInfoWrapper>
          <Markdown text={content[lang.toLowerCase() as keyof LoString] ?? Object.values(content).pop() ?? ""} />
        </StyledContentWrapper>
      </GrStack>
      <GrStack height="32px" margin="8px 0 0 0" justifyContent="flex-end" alignItems="center">
        <Style.CloseButton color="grey" onClick={handleReleasePopupClose}>
          {MvnMessage({ en: "Close", ko: "닫기" })}
        </Style.CloseButton>
      </GrStack>
    </Style.PopupWrapper>
  );
}

const StyledReleaseTitleWrapper = styled.p`
  height: "17.5px";
  margin: "16px 0 0 0";
`;

const StyledLabelTextWrapper = styled(Style.TextWrapper)(({ width }: { width?: string }) => ({
  width: width ?? "5rem",
  color: palette.grey060,
  marginRight: "0.5rem",
}));

const StyledContentWrapper = styled("div")({
  display: "flex",
  height: "calc(100% - 3.15rem)",
  flexDirection: "column",
  overflow: "auto",
});
